/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const ChevronUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Chevron Up"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#0E0E0E"
      fillRule="evenodd"
      d="M4.94 15.06a1.5 1.5 0 0 1 0-2.12l6-6a1.5 1.5 0 0 1 2.12 0l6 6a1.5 1.5 0 0 1-2.12 2.12L12 10.122l-4.94 4.94a1.5 1.5 0 0 1-2.12 0"
      className="SVG"
      clipRule="evenodd"
    />
  </svg>
);

export const ChevronUpIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'chevron-up-icon'}
      icon={ChevronUp}
      {...props}
      size={size}
    />
  );
};
